import axios from 'axios'

export default class RegiaoGeografica {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/regiaoGeografica`
    this.tokenBearer = tokenBearer
  }

  getRegioes () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getEstado (estadoId) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.url + '/' + estadoId,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
